module.exports = __webpack_public_path__ + "img/marker-nodisc-orange.ab2039ed.png";